/**
 * ChatBot Component Constants
 *
 * Centralized configuration values and magic numbers
 */

// ---------- Timing Constants ----------
export const TIMING = {
  /** Delay before transitioning from 'thinking' to 'processing' status */
  THINKING_TO_PROCESSING_DELAY: 250,
  /** Delay before transitioning from 'processing' to 'generating' status */
  PROCESSING_TO_GENERATING_DELAY: 150,
  /** Debounce delay for scroll operations */
  SCROLL_DEBOUNCE_DELAY: 100
} as const

// ---------- Storage Constants ----------
export const STORAGE = {
  /** Prefix for sessionStorage keys */
  SESSION_PREFIX: 'chat_session_',
  /** Key for global session when no case ID is available */
  GLOBAL_SESSION_KEY: 'chat_session_global'
} as const

// ---------- GraphQL Constants ----------
export const GRAPHQL = {
  /** End-of-stream marker from server */
  END_MESSAGE_MARKER: '#endmessage'
} as const

// ---------- UI Constants ----------
export const UI = {
  /** CSS class for dragging state */
  DRAGGING_CLASS: 'dragging',
  /** Maximum number of retry attempts for failed operations */
  MAX_RETRY_ATTEMPTS: 3,
  /** Scroll behavior for auto-scroll */
  SCROLL_BEHAVIOR: 'smooth' as ScrollBehavior,
  /** Scroll block position */
  SCROLL_BLOCK: 'end' as ScrollLogicalPosition
} as const

// ---------- Error Messages ----------
export const ERROR_MESSAGES = {
  STREAMING_ERROR: 'Streaming error occurred.',
  CHAT_SERVICE_UNAVAILABLE: 'Chat service unavailable',
  SESSION_STORAGE_UNAVAILABLE: 'Session storage is unavailable',
  INVALID_CASE_ID: 'Invalid case ID provided',
  SUBSCRIPTION_FAILED: 'Failed to establish chat subscription'
} as const
